import { DEFAULT_CSS_CLASS } from '@constants';
import { getBlockClassNames } from '@components/class-dropdown';
import BackgroundTypesSave from '@components/background-types/save';
import { flexClasses } from '@helpers/utils.js';
import classnames from 'classnames';

const {
  blockEditor: { InnerBlocks, useBlockProps },
} = wp;

const Save = ({ attributes }) => {
  const {
    blockId,
    blockClassNames,
    backgroundType,
    backgroundGradientOptions,
    backgroundColorOptions,
    backgroundImageOptions,
    backgroundImageAndColorOptions,
    imageAsBackgroundOptions,
    backgroundVideoOptions,
    imageGradientBackgroundOptions,
    columnSize,
    flexSettings,
    printBackgroundStyles,
  } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.COLUMN;
  const defaultBlockDynamicCssClass = `${defaultBlockCssClass}-${blockId}`;
  const classNames = getBlockClassNames(blockClassNames);
  const flexSettingsClass = flexClasses(flexSettings);
  const columnSizeClass = Object.entries(columnSize)
    // eslint-disable-next-line no-unused-vars
    .filter(([key, value]) => value !== 0)
    .reduce((classes, [key, value]) => `${classes} col-${key}-${value}`, '');

  const blockProps = useBlockProps.save({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${defaultBlockDynamicCssClass}`]: defaultBlockDynamicCssClass,
      [`${classNames}`]: classNames,
      [`${columnSizeClass}`]: columnSizeClass,
      [`${flexSettingsClass}`]: flexSettingsClass,
    }),
  });

  return (
    <div {...blockProps}>
      <BackgroundTypesSave
        {...{
          blockId,
          defaultBlockCssClass,
          backgroundType,
          backgroundGradientOptions,
          backgroundColorOptions,
          backgroundImageOptions,
          backgroundImageAndColorOptions,
          imageAsBackgroundOptions,
          backgroundVideoOptions,
          imageGradientBackgroundOptions,
          printBackgroundStyles,
        }}
      />
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
